<template>
    <div class="setting_wrap service_use_agreement">
        <TermsOfUse></TermsOfUse>
        <PersonalUsage></PersonalUsage>
    </div>
</template>
<script>
    import TermsOfUse from './termsOfUse';
    import PersonalUsage from './personalUsage'

    export default {
        name: 'ServiceUseAgreement',
        components: {TermsOfUse, PersonalUsage},
        data() {
            return {
            }
        },
        methods: {
        },
    }
</script>
<style lang="scss">
</style>